import React from 'react';
import styles from './TableCell.module.css';

export interface TableCellProps extends React.TdHTMLAttributes<HTMLTableDataCellElement> {
  children: React.ReactNode;
}

/**
 * A single cell (<td>) within the table body row.
 */
export const TableCell: React.FC<TableCellProps> = ({ children, className, ...props }) => {
  return (
    <td className={`${styles.cell}${className ? ` ${className}` : ''}`} {...props}>
      {children}
    </td>
  );
};
